exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SoundTypes-module__grid-wrapper___oj81D{display:grid;gap:14px}@-moz-document url-prefix(){.SoundTypes-module__grid-wrapper___oj81D{margin-right:15px}}.SoundTypes-module__row___3aP0V{justify-items:start;gap:.75em}.SoundTypes-module__multiple-items___1vk9G,.SoundTypes-module__row___3aP0V{display:grid;grid-auto-flow:column;justify-content:start}.SoundTypes-module__multiple-items___1vk9G{gap:.2em}", ""]);

// exports
exports.locals = {
	"grid-wrapper": "SoundTypes-module__grid-wrapper___oj81D",
	"row": "SoundTypes-module__row___3aP0V",
	"multiple-items": "SoundTypes-module__multiple-items___1vk9G"
};